import script from "./DashboardView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardView.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardView.vue?vue&type=style&index=0&id=3fa5ea1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fa5ea1e"]])

export default __exports__